'use client';
import type { EntityCountByLocation } from '@repo/supergraph-schemas/base/metadata/types';
import { STATES_MAP } from '@repo/supergraph-schemas/marketplace/constants';
import { overrideGeoTargetedTitle } from '../../../utils/geo-data';
import { PageHeader } from '../../PageHeader';
import { useGeo } from '../GeoProvider';

export type HeaderProps = {
  title: string;
  titleWithoutEntityCount?: string;
  excludeEntityCountFromTitle?: boolean;
  entityCountByLocation?: EntityCountByLocation;
  filteredEntityCount?: number;
  showBestOf?: boolean;
};

export const GeoHeader: React.FC<HeaderProps> = ({ showBestOf, ...rest }) => {
  const { isReady, regionCode } = useGeo();
  const title = overrideGeoTargetedTitle(rest, regionCode);

  return (
    <PageHeader
      title={title}
      {...(!!isReady && !!regionCode && { disclosureSectionTitle: STATES_MAP[regionCode] })}
      showBestOf={showBestOf}
    />
  );
};
